import type { PayoutTargetBankAccount } from "@@/shared/financials/payout-targets/payout-target-bank-account";
import {
    payoutTargetBankAccountTypeZodSchema,
    payoutTargetBankAccountZodSchema,
} from "@@/shared/financials/payout-targets/payout-target-bank-account";
import { z } from "zod";
import type { PayoutTargetBankgiro } from "./payout-target-bankgiro";
import {
    payoutTargetBankgiroTypeZodSchema,
    payoutTargetBankgiroZodSchema,
} from "./payout-target-bankgiro";
import type { PayoutTargetPlusgiro } from "./payout-target-plusgiro";
import {
    payoutTargetPlusgiroTypeZodSchema,
    payoutTargetPlusgiroZodSchema,
} from "./payout-target-plusgiro";

type PayoutTarget =
    | PayoutTargetBankgiro
    | PayoutTargetBankAccount
    | PayoutTargetPlusgiro;

const payoutTargetZodSchema = z.union([
    payoutTargetBankgiroZodSchema,
    payoutTargetBankAccountZodSchema,
    payoutTargetPlusgiroZodSchema,
]);

type PayoutTargetType = PayoutTarget["type"];
const payoutTargetTypeZodSchema: z.ZodSchema<PayoutTargetType> = z.union([
    payoutTargetBankgiroTypeZodSchema,
    payoutTargetBankAccountTypeZodSchema,
    payoutTargetPlusgiroTypeZodSchema,
]);

export { payoutTargetTypeZodSchema, payoutTargetZodSchema };
export type { PayoutTarget, PayoutTargetType };
